oldGetScript